import React from 'react';

interface TopicTagsProps {
    topics: string[];
    className?: string;
}

export const TopicTags: React.FC<TopicTagsProps> = ({
    topics,
    className = '',
}) => {
    return (
        <div className={`researcher-topics ${className}`}>
            {topics.map((topic, index) => (
                <span key={index} className="researcher-topic">
                    {topic}
                </span>
            ))}
        </div>
    );
};

export default TopicTags;
